{
  "_note": "Langue source du site (français). Les autres langues sont des traductions à faire valider avant la mise en production.",
  "meta": {
    "title": "Concours Hippique International de Megève 2027",
    "description": "Concours Hippique International de Megève, au cœur du village : 19-20 et 23-27 juin 2027, entrée gratuite. National, Club, CSI4*, CSI2*, CSI1*.",
    "ogImageAlt": "Aiguille Croche, Megève"
  },
  "nav": {
    "language": "Langue",
    "skip": "Aller au contenu",
    "concours": "Le concours",
    "programme": "Programme",
    "infos": "Infos pratiques",
    "contact": "Contact",
    "sections": "Sections de la page",
    "menu": "Menu",
    "close": "Fermer le menu"
  },
  "hero": {
    "riderAlt": "Cavalier en saut d'obstacles",
    "title": "Megeve",
    "month": "Juin",
    "cta": "Plus d'informations",
    "subtitle1": "Concours hippique",
    "subtitle2": "- International -"
  },
  "form": {
    "title": "Demande d'informations",
    "firstname": "Prénom",
    "lastname": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "message": "Votre message",
    "consent": "J'accepte que les données saisies dans ce formulaire soient traitées afin de répondre à ma demande d'information.",
    "consentLink": "En savoir plus sur le traitement de mes données",
    "consentHref": "/mentions-legales.html#donnees",
    "submit": "Envoyer",
    "errors": {
      "firstnameRequired": "Merci d’indiquer votre prénom.",
      "firstnameMin": "Votre prénom doit comporter au moins 2 caractères.",
      "lastnameRequired": "Merci d’indiquer votre nom.",
      "lastnameMin": "Votre nom doit comporter au moins 2 caractères.",
      "emailRequired": "Merci d’indiquer votre adresse e-mail.",
      "emailInvalid": "Cette adresse e-mail ne semble pas valide.",
      "phoneInvalid": "Numéro de téléphone invalide (ex. 06 12 34 56 78 ou +33 6 12 34 56 78).",
      "messageRequired": "Merci de saisir votre message.",
      "messageMin": "Votre message doit comporter au moins 10 caractères.",
      "messageMax": "Votre message ne peut pas dépasser 2000 caractères.",
      "consentRequired": "Vous devez accepter le traitement de vos données pour envoyer votre demande."
    },
    "errorsSummary": "Le formulaire contient des erreurs :"
  },
  "partners": {
    "label": "Partenaires et organisateurs",
    "ffe": "Fédération Française d'Équitation"
  },
  "footer": {
    "copy": "© Concours Hippique International de Megève",
    "madeWith": "Fait avec",
    "by": "par",
    "legal": "Mentions légales"
  },
  "legal": {
    "metaTitle": "Mentions légales, CGU et politique de confidentialité — Concours Hippique International de Megève",
    "metaDescription": "Mentions légales, conditions générales d'utilisation, politique de confidentialité et politique cookies du site, dont le traitement des données du formulaire de demande d'informations.",
    "homeAlt": "Megève — retour à l'accueil"
  },
  "seo": {
    "nationalName": "Concours National et Club de Megève",
    "internationalName": "Concours de Saut International de Megève (CSI4*, CSI2*, CSI1*)"
  },
  "s": {
    "essentials": {
      "label": "L'essentiel",
      "free": "Entrée gratuite",
      "parking": "Parking gratuit",
      "food": "Restauration sur place",
      "start": "Début des épreuves à 8h00*",
      "startNote": "*Horaire sous réserve de modification"
    },
    "village": {
      "title": "Concours Hippique International de Megève, au cœur du village !",
      "lead": "<strong>Du 19 au 27 juin 2027</strong>, le cheval s'installe au cœur du village de Megève, sur l'esplanade du Palais des Sports, pour une parenthèse sportive et festive inaugurant la saison estivale.",
      "historyTitle": "Le cheval et Megève, une histoire commune",
      "historyText": "À Megève, le cheval fait partie de l'identité du village. Au-delà du sport de haut niveau, le concours réunira habitants, visiteurs, commerçants et professionnels autour d'un <strong>événement international ancré</strong> dans son territoire, où le Cheval de Megève occupera une place particulière.",
      "charmTitle": "Le charme d'un village authentique",
      "festiveTitle": "Un rendez-vous festif à vivre ensemble",
      "festiveText": "Pensé comme un événement chaleureux, festif et accessible à tous, le public est invité à découvrir <strong>gratuitement</strong> l'univers équestre. Les <strong>jeudi et vendredi</strong>, une fois la nuit tombée, <strong>deux soirées</strong> mêlant sport et ambiance festive vous seront proposées. De quoi prolonger l'effervescence au cœur du village de Megève.",
      "activities": "Le Concours Hippique International de Megève ne se vit pas uniquement depuis les tribunes. Autour de la piste et dans le village, de nombreuses activités pour les petits et les grands seront à découvrir : <strong>balades à poney</strong>, <strong>parcours de saut d'obstacles avec des chevaux bâton</strong>, … autant de découvertes pour approcher le monde équestre de manière ludique et conviviale.",
      "guard": "La Garde républicaine sera également présente pour une parade inédite au cœur du village !"
    },
    "programme": {
      "title": "Programme",
      "year": "2027",
      "d1Days": "Sam. 19 - Dim. 20 juin",
      "d1Label": "Épreuves Nationales & Clubs",
      "d2Days": "Mer. 23 - Dim. 27 juin",
      "d2Label": "CSI4* - CSI2* - CSI1*",
      "eliteTitle": "L'élite équestre mondiale",
      "eliteSub": "réunie autour de 3 labels internationaux",
      "teamTitle": "Une équipe de piste d'excellence",
      "team1": "<strong>Le Concours Hippique International de Megève</strong> accueillera bon nombre des meilleurs cavaliers du monde, pour cinq jours d'épreuves intenses, avec un <strong>CSI4*</strong>, un <strong>CSI2*</strong> et un <strong>CSI1*</strong>.",
      "team2": "Point d'orgue de la semaine : le <strong>Grand Prix 4* coté à 1,60 m</strong> promet une confrontation au sommet entre les meilleurs couples du week-end.",
      "team3": "Pour concevoir les parcours, le réputé <strong>chef de piste olympique Grégory Bodo</strong> sera aux commandes d'une équipe expérimentée, prêt à proposer un spectacle sportif à couper le souffle !",
      "preamble": "En préambule de cette semaine internationale, le village vibrera dès le week-end précédent au rythme des <strong>épreuves nationales et clubs</strong>. Un premier temps fort convivial et formateur, pensé pour mettre en lumière la relève et les cavaliers régionaux sur cette même piste d'exception."
    },
    "welfare": {
      "title": "Pour le bien-être de nos chevaux",
      "text": "Le <strong>bien-être équin</strong> reste une <strong>priorité</strong> pour le Megève Concours Hippique International. Le site offrira des infrastructures de grande qualité : piste en sable Toubin & Clément, paddock couvert, carrière extérieure de détente, rond d'Havrincourt et boxes sur plancher."
    },
    "info": {
      "title": "Informations pratiques",
      "nationalLabel": "Compétitions Nationales & Clubs",
      "nationalDates": "Samedi 19 et Dimanche 20 juin 2027",
      "intlLabel": "Compétitions Internationales",
      "intlDates": "Du Mercredi 23 au Dimanche 27 juin 2027",
      "venueLabel": "Lieu",
      "venueName": "Palais des sports de Megève",
      "venueAddress1": "247 Route du Palais des Sports,",
      "venueAddress2": "74120 Megève",
      "directions": "Itinéraire"
    },
    "photos": {
      "v1": "Vue plongeante sur Megève et les montagnes qui l'entourent",
      "v2": "La place du village, sa tour ronde et ses calèches",
      "v3": "L'église de Megève et les maisons du centre, au milieu des fleurs",
      "v4": "La vallée de Megève vue depuis les prairies",
      "place": "La place du village de Megève, fleurie et ensoleillée",
      "piste": "Un cavalier franchit un obstacle sur la piste du concours",
      "welfare": "Gros plan sur la tête d'un cheval"
    }
  },
  "msg_send": "Merci, votre demande a bien été envoyée. Nous vous répondrons rapidement.",
  "msg_not_send": "Une erreur est survenue lors de l'envoi. Merci de réessayer plus tard."
}
